const routers = [
  "/",
  "/inicio",
  "/history",
  "/tareas",
  "/Profesionales",
  "/perfilTermico",
  "/soporte",
  "/informacion/:name",
  "/agenda/:name",
  "/check",
  "/profile",
  "/ahorro",
  "/pagos",
  "/diario",
  "/calendario-diario",
  "/nota",
  "/test",
  "/resultados/",
];
export default routers;
